<template>
    <v-container fill-height class="align-start mt-3">
        <v-row>
            <v-col md="10" offset-md="1">
                <team-card v-for="team of teams" :key="team" :index="team" :game="fakeGames[team]" :canEdit="team == teams.length - 1" @gameDone="teamResults($event)" class="my-4"></team-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import TeamCard from "../components/TeamCard"
import utils from '../utils'
    export default {
        name: "Teams",
        components: {
            TeamCard
        },
        data() {
            return {
                teams: [0],
                fakeGames: []
            }
        },
        methods: {
            teamResults(results){                
                if(results.index === this.teams.length -1){
                    if(this.$store.state.games[0].id != results.game.id){
                        this.teams.push(results.index + 1);
                        this.fakeGames.push(results.game)
                        this.$store.commit("addGame", results.game)
                    } else {
                        this.fakeGames[results.index] = results.game                    
                        this.$store.commit("updateGame", results.game)
                    }
                } else {                                        
                    this.fakeGames[results.index] = results.game                    
                    this.$store.commit("updateGame", results.game)
                }
                console.log(results)
                utils.calculateElos(this.$store.state.games, this.$store.state.players)
                let len = this.$store.state.games.length
                console.log(this.$store.state.games[len - 1])
            },
            findFakes(){
                let games = this.$store.state.games
                let position = 0
                let index = games.findIndex(game => game.name == "FakeGame " + position)    
                this.teams = []
                while(index != -1){
                    this.teams.push(position)
                    this.fakeGames.unshift(games[index])
                    position++
                    index = games.findIndex(game => game.name == "FakeGame " + position)
                    console.log(position)
                }
                this.teams.push(this.teams.length)
                
            }
        },
        computed: {
            ...mapGetters(['numberOfGames']),
        },
        watch: {
            numberOfGames(){
                if(this.fakeGames.length == 0) this.findFakes()                
            }
        },
        mounted(){
            if(this.numberOfGames > 0) this.findFakes()
        }
    }                
</script>

<style lang="scss" scoped>

</style>